module.exports = __webpack_public_path__ + "img/00027.8dd05ab7.webp";